import { call } from './client'
import type { Account } from '../types'

export const accounts = (): Promise<Account[]> => call('/accounts')
